module.exports = __webpack_public_path__ + "media/icons/envelope--blue-large-d59c5216.svg";